export default __webpack_public_path__ + "static/media/bfR.2481d68f.gif";